import { NumberFormat } from '@billy/design-system'
import { TFunction } from 'i18next'

import { getCurrentLocale } from '../../../utils/getCurrentLocale'
import { productPayloadColumns } from '../constants/productPayloadColumns'
import { SelectableProductAccount } from '../query-api'
import { Product } from '../types/product'

interface GetProductsExportDataOptions {
  accounts?: SelectableProductAccount[]
}

const getCellValue = (
  product: Product,
  column: keyof Product,
  locale: string,
  accounts: SelectableProductAccount[],
) => {
  if (column === 'vatPct') {
    return product.vatPct == null ? '' : NumberFormat.getPercentNumber(product.vatPct, locale)
  }

  if (column === 'accountId') {
    return accounts.find(({ id }) => id === product.accountId)?.accountNo ?? ''
  }

  return product[column] ?? ''
}

export const getProductsExportData = (
  products: Product[],
  t: TFunction,
  { accounts }: GetProductsExportDataOptions = {},
): (string | number)[][] => {
  const locale = getCurrentLocale()
  const columns = accounts ? productPayloadColumns : productPayloadColumns.filter(({ key }) => key !== 'accountId')
  const header = columns.map(({ labelKey }) => t(labelKey))
  const rows = products.map((product) => columns.map(({ key }) => getCellValue(product, key, locale, accounts ?? [])))

  return [header, ...rows]
}
